import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { baseExtraReducers, baseGetData, baseInitialState, baseReducers } from 'helpers/slice.helper';
import { APP_URLS } from 'constants/url.constant';

const name = 'consultation';

export const getData = createAsyncThunk(
    `${name}/getData`,
    async props => await baseGetData({ url: APP_URLS.COUNSELOR_CONSULTATIONS.replace(':id', props['id']), ...props })
);

export const defaultFilters = {};

const consultationSlice = createSlice({
    name,
    initialState: {
        ...baseInitialState,
        filters: defaultFilters,
        sorter: {
            field: 'date',
            order: 'descend',
        },
        pagination: { ...baseInitialState.pagination, pageSize: 1000 },
    },
    reducers: {
        ...baseReducers,
    },
    extraReducers: baseExtraReducers(getData),
});

export const { setLoading, setData, setPagination, setFilters, setSorter, setHideColumns, setSelection } =
    consultationSlice.actions;

export default consultationSlice.reducer;
